export const headerHeight = 42;
export const topMenuHeight = 55;

export const totalHeaderHeight = headerHeight + topMenuHeight;
export const photoResizeDelay = .01;

export const resetPasswordSuccessMessage = 'Password reset link was sent';
export const resendUsernameSuccessMessage = 'Username reminder email was sent';
